import { render } from "./Dialogs.vue?vue&type=template&id=15bd77c6&scoped=true"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"

import "./Dialogs.vue?vue&type=style&index=0&id=15bd77c6&scoped=true&lang=css"
import "./Dialogs.vue?vue&type=style&index=1&id=15bd77c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bd77c6"]])

export default __exports__